module.exports = __webpack_public_path__ + "img/pin_take_away_orange.55e1fd09.svg";